"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePasswordRecoveryResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validatePasswordRecoveryResult = (0, validation_1.properties)({
    message: (0, validation_1.text)(),
});
//# sourceMappingURL=PasswordRecoveryResult.js.map